module.exports = __webpack_public_path__ + "img/4-ruby.30906437.png";